var publicData = require('./services/publicData');

var authorization = require('./services/authorization');
var router = require('./services/router');
var helpers = require('./services/helpers');

var preloader = require('./components/preloader');
var messages = require('./components/messages');

var RequestAccount = function () {
    var self = this;

    this.name = ko.observable('');
    this.email = ko.observable('');
    this.school = ko.observable('');

    this.references_list = publicData.references_list;

    this.is_request_sent = ko.observable(false);

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.getData = function () {
        return {
            name: self.name(),
            email: self.email(),
            school: self.school()
        }
    };

    this.isValid = function () {
        var messages_list = [];
        var target_focus;

        self.name(self.name().trim());
        self.email(self.email().trim());

        if (!self.school()) {
            target_focus = 'school';
            messages_list.push('Please, select your "school" field');
        }
        if (self.email().length == 0) {
            target_focus = 'email';
            messages_list.push('Please, fill "email" field');
        } else if (!helpers.validateEmail(self.email())) {
            target_focus = 'email';
            messages_list.push('Wrong "email" field format');
        }
        if (self.name().length == 0) {
            target_focus = 'name';
            messages_list.push('Please, fill "name" field');
        }

        if (messages_list.length == 0) return true;

        messages.addItems(messages_list.reverse(), {clear: true});
        helpers.focusSequence(messages_list.join(' '), function () {
            self.focused(target_focus);
        });

        return false;
    };

    this.clean = function (options) {
        if (!options || options.name) self.name('');
        if (!options || options.email) self.email('');
        if (!options || options.school) self.school(null);
    };

    this.sendRequest = function () {
        messages.removeAllItems();

        if (!self.isValid()) return;

        preloader.show('request-account');
        authorization.requestAccount(function (status, message) {
            preloader.hide('request-account');
            if (!status) return;

            self.clean();

            self.is_request_sent(true);
            self.focused('sent_request_message');
        }, self.getData());
    };

    this.onShow = function () {
        self.focused('title');
    }
};

module.exports = RequestAccount;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/RequestAccountPage.js
// module id = 26
// module chunks = 0